import { useAuth } from '../../../../hooks/useAuth';
import { toRosterSport, type RosterSport } from '../../../../constants/sport';

/**
 * The sport a roster board is drawn for, resolved the way web/CLAUDE.md prescribes.
 *
 * The coach's own organization (`user.profile.sport`) is the normal source. `activeOrganization`
 * is only set while a system admin impersonates an org, and wins then, even when it carries no
 * sport. Reading `activeOrganization` alone, as the board used to, drew every real softball coach
 * a baseball field.
 */
export const useRosterSport = (): RosterSport => {
  const auth = useAuth();
  return toRosterSport(
    auth?.activeOrganization ? auth.activeOrganization.sport : auth?.user?.profile?.sport,
  );
};
